import React from "react"
import styled from "styled-components"

export default function Logo () {



    return (

        <Banner>
            CINEFLEX



        </Banner>


    )
}

const Banner = styled.div`
width:100%;
height: 67px;
background-color: #C3CFD9;
color: orange;
font-size: 28px;
display:flex;
align-items:center;
justify-content:center;
`